import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { KiaContext } from '../../../common/context/main.context';
import Button from '../../01_atoms/button/Button';
import Banner from './Banner';

export default function EasyMoveLegalBanner() {
  const {
    isB2c,
    showMonthlyPrices,
    legal,
    representativePopup,
    showEasyMoveLegalBanner,
    setShowEasyMoveLegalBanner,
  } = useContext(KiaContext);

  if (!showMonthlyPrices || !isB2c) return null;

  const html = representativePopup || legal?.representative_example || '';

  return (
    <React.Fragment>
      {showEasyMoveLegalBanner ? (
        <Banner name="easymove" actions={<Button mode="outline" color="light" size="small" onClick={() => setShowEasyMoveLegalBanner(false)}>
          <FormattedMessage id="banner.ok" /></Button>}>
          <Button size="small" className="banner__trigger" onClick={() => setShowEasyMoveLegalBanner(false)}>Legal Info</Button>
          <h4 className="fs--legal bold"><FormattedMessage id="legal.attention" /></h4>
          <p><FormattedMessage id="banner.example" />:</p>
          {html ? <div dangerouslySetInnerHTML={{ __html: html }} className="p--2" /> : null}
        </Banner>
      ) : (
        <Button size="small" className="banner__trigger" onClick={() => setShowEasyMoveLegalBanner(true)}>Legal Info</Button>
      )}
    </React.Fragment>
  );
}
